// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselTestimonials {
    constructor() {
        // element that will be wrapped
        const carousel = document.querySelector(".carousel-testimonials");

        if (carousel) {
            const carouselTrack = document.querySelector(
                ".carousel-testimonials .wp-block-group"
            );
            const carouselSlides = carouselTrack.querySelector(
                ".carousel-testimonials .wp-block-group .wp-block-group"
            );
            const carouselIndividualSlide = carouselTrack.querySelectorAll(
                ".carousel-testimonials .wp-block-group .wp-block-group .wp-block-quote"
            );

            // Add Glide classes
            carouselTrack.classList.add("glide__track");
            carouselTrack.dataset.glideEl = "track";
            carouselSlides.classList.add("glide__slides");
            carouselIndividualSlide.forEach((item) => {
                item.classList.add("glide__slide");
            });

            // Tweak styles
            carousel.style.overflow = "hidden";
            carouselSlides.style.flexWrap = "nowrap";

            // Mount carousel
            var threeSlideGlide = new Glide(".carousel-testimonials", {
                type: "carousel",
                perView: 1,
                autoplay: 5000,
            }).mount();
        }
    }
}

export default CarouselTestimonials;
